import AbstractProvidedClass from "../shared/AbstractProvidedClass";

const SPINNER_CSS = `
    @keyframes plannerSpin { to { transform: rotate(360deg); } }
    .planner-spinner-ring {
        width: 48px; height: 48px;
        border: 5px solid #ddd;
        border-top-color: #333;
        border-radius: 50%;
        animation: plannerSpin 0.75s linear infinite;
    }
`;

export default class Spinner extends AbstractProvidedClass {
    overlay = null;

    showFullscreen() {
        this.reset();
        this._ensureCss();
        this.overlay = document.createElement('div');
        this.overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.88);display:flex;align-items:center;justify-content:center;z-index:9999;';
        const ring = document.createElement('div');
        ring.className = 'planner-spinner-ring';
        this.overlay.appendChild(ring);
        document.body.appendChild(this.overlay);
    }

    showSidebar() {
        this.reset();
        this._ensureCss();
        const sidebar = document.getElementById('sidebar');
        if (!sidebar) return;
        this.overlay = document.createElement('div');
        this.overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.75);display:flex;align-items:center;justify-content:center;z-index:10;';
        const ring = document.createElement('div');
        ring.className = 'planner-spinner-ring';
        this.overlay.appendChild(ring);
        sidebar.appendChild(this.overlay);
    }

    reset() {
        this.overlay?.remove();
        this.overlay = null;
    }

    display() {}

    _ensureCss() {
        if (!document.getElementById('planner-spinner-css')) {
            const style = document.createElement('style');
            style.id = 'planner-spinner-css';
            style.textContent = SPINNER_CSS;
            document.head.appendChild(style);
        }
    }
}
